import React from 'react';
import Services from '../components/Services.js';
import SEO from '../components/SEO.js';

const servicesSchema = {
  "@context": "https://schema.org",
  "@type": "ItemList",
  "name": "Vijay Industry Services",
  "url": "https://vijayindustry.co.in/services",
  "itemListElement": [
    {
      "@type": "ListItem",
      "position": 1,
      "item": {
        "@type": "Service",
        "name": "Pre-Engineered Buildings (PEB)",
        "description": "Custom designed, high-strength pre-engineered steel buildings engineered for rapid installation and extreme structural durability."
      }
    },
    {
      "@type": "ListItem",
      "position": 2,
      "item": {
        "@type": "Service",
        "name": "Factory Sheds",
        "description": "Spacious, heavy-duty industrial sheds engineered to host heavy factory operations, assembly lines, and crane installations."
      }
    },
    {
      "@type": "ListItem",
      "position": 3,
      "item": {
        "@type": "Service",
        "name": "Industrial Warehouses",
        "description": "Large-capacity, weather-proof steel warehouse structures built to optimize storage space and secure commercial inventory."
      }
    },
    {
      "@type": "ListItem",
      "position": 4,
      "item": {
        "@type": "Service",
        "name": "Steel Showrooms",
        "description": "Modern, column-free commercial buildings featuring large open spans and glass frontages to elevate product displays."
      }
    },
    {
      "@type": "ListItem",
      "position": 5,
      "item": {
        "@type": "Service",
        "name": "Mezzanine Floors",
        "description": "Heavy-duty structural steel mezzanine floor systems designed to multiply storage or workspace within an existing footprint."
      }
    },
    {
      "@type": "ListItem",
      "position": 6,
      "item": {
        "@type": "Service",
        "name": "Structural MS & SS Works",
        "description": "Custom mild steel and stainless steel gates, handrailings, and structural steel fabrication for industrial & commercial projects."
      }
    }
  ]
};

export default function ServicesPage() {
  return (
    <div className="page-services animate-fade-in">
      <SEO 
        title="PEB Buildings, Factory Sheds & Warehouse Services | Vijay Industry"
        description="Explore Vijay Industry's PEB structural engineering services: Pre-Engineered Steel Buildings, Factory Sheds, Warehouses, Showrooms, Mezzanine Floors, and MS/SS Fabrication."
        keywords="PEB Services Coimbatore, Factory Shed Manufacturers, Steel Warehouse Construction, Mezzanine Floors, Commercial Showroom Steel Structure"
        canonical="/services"
        schemaData={servicesSchema}
      />
      {/* Page Header Banner */}
      <div 
        style={{ 
          backgroundColor: 'var(--primary)', 
          color: 'var(--surface)', 
          padding: '4rem 0',
          position: 'relative',
          overflow: 'hidden',
          borderBottom: '4px solid var(--accent)'
        }}
      >
        <div className="container" style={{ position: 'relative', zIndex: 2 }}>
          <h1 style={{ color: 'var(--surface)', fontSize: '2.5rem', marginBottom: '0.5rem' }}>
            Our Services
          </h1>
          <p style={{ color: '#94A3B8', maxWidth: '600px', fontSize: '1.1rem' }}>
            Premium pre-engineered building solutions engineered to stand strong, install fast, and maximize cost-efficiency.
          </p>
        </div>
      </div>
      
      {/* Full Services Grid Component */}
      <Services />
    </div>
  );
}
